import { ApiClient } from '../../core/api/ApiClient';
import { API_BASE_URL } from '../../core/config/api';
import LogUtil from '../../core/utils/LogUtil';
import { PharmacyAuthRepositoryImpl } from './implementations';
import { PharmacyAuthService } from './services';

// PharmacyAuth Domain Exports
export * from './implementations';
export * from './interfaces';
export * from './services';

/**
 * PharmacyAuth Domain Dependency Injection Container
 * 의존성 주입을 통한 클린 아키텍처 구현
 */
class PharmacyAuthDomainContainer {
  constructor() {
    this._apiClient = null;
    this._pharmacyAuthRepository = null;
    this._pharmacyAuthService = null;
  }

  get apiClient() {
    if (!this._apiClient) {
      this._apiClient = new ApiClient(API_BASE_URL);
      LogUtil.log('🔧 [PharmacyAuth Container] ApiClient 초기화 완료:', API_BASE_URL);
    }
    return this._apiClient;
  }

  get pharmacyAuthRepository() {
    if (!this._pharmacyAuthRepository) {
      this._pharmacyAuthRepository = new PharmacyAuthRepositoryImpl(this.apiClient);
      LogUtil.log('🔧 [PharmacyAuth Container] PharmacyAuthRepositoryImpl 초기화 완료');
    }
    return this._pharmacyAuthRepository;
  }

  get pharmacyAuthService() {
    if (!this._pharmacyAuthService) {
      this._pharmacyAuthService = new PharmacyAuthService(this.pharmacyAuthRepository);
      LogUtil.log('🔧 [PharmacyAuth Container] PharmacyAuthService 초기화 완료');
    }
    return this._pharmacyAuthService;
  }

  /**
   * 컨테이너 초기화 (테스트용)
   */
  reset() {
    this._apiClient = null;
    this._pharmacyAuthRepository = null;
    this._pharmacyAuthService = null;
  }
}

// Singleton 인스턴스
const container = new PharmacyAuthDomainContainer();

/**
 * PharmacyAuth Service 싱글톤 접근자
 * @returns PharmacyAuthService 인스턴스
 */
export const getPharmacyAuthService = () => container.pharmacyAuthService;

/**
 * PharmacyAuth Repository 싱글톤 접근자 (테스트용)
 * @returns PharmacyAuthRepositoryImpl 인스턴스
 */
export const getPharmacyAuthRepository = () => container.pharmacyAuthRepository;

/**
 * 컨테이너 리셋 (테스트용)
 */
export const resetPharmacyAuthContainer = () => container.reset();
